let prefix = '/api/delayEvent';

function getDelayEvent() {
    return window.axios.get(prefix);
}
function getByDates(data) {
    return window.axios.get(prefix+'/ByDates',{params:data});
}
function getByDatesShow(data) {
    return window.axios.post(prefix + '/show', data );
}
function getByShift(data) {
    return window.axios.get(prefix+'/byShift',{params:data});
}
function store(data) {
    return window.axios.post(prefix, data);
}
function deleteDelayEvent(id) {
    return window.axios.delete(prefix+'/'+id);
}
function update(id,data) {
    return window.axios.patch(prefix+'/'+id,data);
}
function completeDelay(id,data) {
    return window.axios.patch(prefix+'/complete/'+id,data);
}

function storeByProduction(data) {
    return window.axios.post(prefix+'/by-production-area',data);
}


export default {
    getDelayEvent, store, deleteDelayEvent, update, getByDates, getByShift, storeByProduction, getByDatesShow, completeDelay  
}